// extracted by mini-css-extract-plugin
module.exports = {"Files":"files_Files__ejIZg","File":"files_File__oGBvb","Name":"files_Name__cmpNX","FilesLanding":"files_FilesLanding__MGvDp"};